import { render } from "./OkrGrade.vue?vue&type=template&id=62e076d8&scoped=true"
import script from "./OkrGrade.vue?vue&type=script&lang=js"
export * from "./OkrGrade.vue?vue&type=script&lang=js"

import "./OkrGrade.vue?vue&type=style&index=0&id=62e076d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e076d8"]])

export default __exports__